import { connect } from 'react-redux';
import ResizedImage from 'shared/components/resized-image/resized-image';
import { getPlayerCoverUrl } from './player-cover-selector';


@connect((state, props) => ({
  coverUrl: getPlayerCoverUrl(state, props),
}))
export class PlayerCover extends React.Component {
  static propTypes = {
    coverUrl: React.PropTypes.string,
    useChannelCoverIfPossible: React.PropTypes.bool,
    coverWidth: React.PropTypes.number,
    coverHeight: React.PropTypes.number,
    className: React.PropTypes.string,
    children: React.PropTypes.any,
  };

  render() {
    const { className, coverUrl, children, coverWidth, coverHeight } = this.props;

    if (!coverUrl) {
      return null;
    }

    return (
      <ResizedImage className={className}
                    src={coverUrl}
                    width={coverWidth}
                    height={coverHeight} >
        {children}
      </ResizedImage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/player-cover/player-cover.js